export default {
  primary: {
    main: "#0D47A1"// #42A5F5"//"#643d74",
  },
  secondary: {
    main: "#0D47A1",
    contrastText: "#fff",
  },
}
